import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { canEditDeploymentGuard } from '../../shared/guards/can-deployment-edit.guard';
import { ComponentDirtyCheckGuard } from '../../shared/guards/component-dirty-check.guard';
import { hasScopesGuard } from '../../shared/guards/has-scopes.guard';
import { assignableShiftsResolver } from '../../shared/resolvers/assignable-shifts.resolver';
import { hasScopesResolver } from '../../shared/resolvers/has-scopes.resolver';
import { deploymentInstanceResolver } from './resolvers/deployment-instance.resolver';
import { deploymentResolver } from './resolvers/deployment.resolver';
import { shiftResolver } from './resolvers/shift.resolver';

export const deploymentRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Deployment.List.Title'),
    loadComponent: () =>
      import('./deployment-list/deployment-list.component').then(
        (m) => m.DeploymentListComponent,
      ),
    resolve: {
      assignableShifts: assignableShiftsResolver,
      hasWriteScope: hasScopesResolver(['deployments:write']),
      hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
    },
  },
  {
    path: 'create',
    title: _('i18n.Deployment.Create.Title'),
    loadComponent: () =>
      import('./deployment-create/deployment-create.component').then(
        (m) => m.DeploymentCreateComponent,
      ),
    canDeactivate: [ComponentDirtyCheckGuard],
    canActivate: [hasScopesGuard(['deployments:write', 'shifts:read'])],
    resolve: {
      assignableShifts: assignableShiftsResolver,
      shift: shiftResolver,
      hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
    },
  },
  {
    path: ':deploymentId',
    children: [
      {
        path: 'detail',
        resolve: {
          deployment: deploymentResolver,
          hasWriteScope: hasScopesResolver(['deployments:write']),
          hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
        },
        loadComponent: () =>
          import('./deployment-detail/deployment-detail.component').then(
            (m) => m.DeploymentDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: {
          deployment: deploymentResolver,
          assignableShifts: assignableShiftsResolver,
        },
        loadComponent: () =>
          import('./deployment-edit/deployment-edit.component').then(
            (m) => m.DeploymentEditComponent,
          ),
        canDeactivate: [ComponentDirtyCheckGuard],
        canActivate: [
          hasScopesGuard(['deployments:write']),
          canEditDeploymentGuard,
        ],
      },
    ],
  },
  {
    path: ':deploymentId/instances/:deploymentInstanceId',
    children: [
      {
        path: 'detail',
        resolve: {
          deploymentInstance: deploymentInstanceResolver,
          hasWriteScope: hasScopesResolver(['deployments:write']),
        },
        loadComponent: () =>
          import('./deployment-instance-detail/deployment-instance-detail.component').then(
            (m) => m.DeploymentInstanceDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: {
          deploymentInstance: deploymentInstanceResolver,
        },
        loadComponent: () =>
          import('./deployment-instance-edit/deployment-instance-edit.component').then(
            (m) => m.DeploymentInstanceEditComponent,
          ),
        canDeactivate: [ComponentDirtyCheckGuard],
        canActivate: [hasScopesGuard(['deployments:write'])],
      },
    ],
  },
];
